import { render } from "./TheHeader.vue?vue&type=template&id=d231dd1a&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=d231dd1a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d231dd1a"

export default script